import script from "./selectUserType.vue?vue&type=script&setup=true&lang=js"
export * from "./selectUserType.vue?vue&type=script&setup=true&lang=js"

import "./selectUserType.vue?vue&type=style&index=0&id=34319332&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34319332"]])

export default __exports__